import { render, staticRenderFns } from "./PaymentConfirmed.vue?vue&type=template&id=24e64730&"
import script from "./PaymentConfirmed.vue?vue&type=script&lang=js&"
export * from "./PaymentConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./PaymentConfirmed.vue?vue&type=style&index=0&id=24e64730&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports